module.exports = __webpack_public_path__ + "img/logo_shell.0efd8e48.png";